import React from "react"
import logoUrl from "../../../assets/img/payment-icons/google_pay.svg"

export default function GooglePayLogo({ sx }: { sx: React.CSSProperties }) {
    return (
        <img
            src={logoUrl} loading="lazy"
            alt="Google Pay logo"
            style={sx}
        />
    )
}
